import React from "react";
import { useRegistrationContext } from "../contexts/registrationContext";
import { uppercase, capitalize } from "../services/utils/format";
import { createTitle } from "../services/utils/createContent";

import { strings } from "../assets/resources/translations";

export default () => {
  const { config } = useRegistrationContext();

  let { title, url, description } = config;

  return (
    <div className="form-section form-header ">
      <h1>{uppercase(title)}</h1>

      {description && (
        <div
          className="text"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      )}
	  
	  {
		<div>
		<div
		  className="text"
		  dangerouslySetInnerHTML={{ __html: strings["paymentTermsInfo"] }}
		/>
		<br />
		<div
		  className="text"
		  dangerouslySetInnerHTML={{ __html: strings["cancellationInfo"] }}
		/>
		<br />
		<div
		  className="text"
		  dangerouslySetInnerHTML={{ __html: strings["travelInsuranceInfo"] }}
		/>
		<br />
		<div
		  className="text"
		  dangerouslySetInnerHTML={{ __html: strings["localTaxesAndFeesInfo"] }}
		/>
	  </div>

	  }


      {url && (
        <div className="text">
		<br />
          <p>
            <a href={url}>{strings["readMoreTrip"]}</a>
          </p>
        </div>
      )}
    </div>
  );
};
